enum TypeLigneMontant {
	PROP_DIR = 'Proposition directe',
	SAI_LIB = 'Saisie libre',
	// Demande creee par l'import d'une idee Vision 360 (renseigne par le back)
	IDEATION = 'Idéation',
}

export default TypeLigneMontant;
